export class CustomerQueryParams {
  constructor(
    public page?: number,
    public pageable?: boolean,
    public itemCount?: number,
    public sortParam?: string[],
    public name?: string,
    public username?: string,
    public surname?: string,
    public email?: string,
    public type?: string,
    public status?: string[],
    public product?: string,
    public subscriberStatus?: boolean,
    public startDate?: number[],
    public endDate?: number[],
    public creationStartDate?: number,
    public creationEndDate?: number,
    public updateStartDate?: number,
    public updateEndDate?: number,
    public accountId?: number,
    public serviceId?: number,
    public boxDeviceId?: string,
    public packageId?: number,
    public profileUid?: string,
    public demoCampaignId?: number,
    public excludeDemo?: boolean,
  ) { }
}